import { render, staticRenderFns } from "./RemoveData.vue?vue&type=template&id=77a82920&scoped=true"
import script from "./RemoveData.vue?vue&type=script&lang=js"
export * from "./RemoveData.vue?vue&type=script&lang=js"
import style0 from "./RemoveData.vue?vue&type=style&index=0&id=77a82920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a82920",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VImg,VTextField})
